const tracks = [
  {
    artist: "7 Days of Funk",
    trackInfo: "7 Days of Funk - Snoop & Dam-Funk - Hit Da Pavement",
    url: "https://www.youtube.com/watch?v=m06muswMot0",
  },
  {
    artist: "Grandmilly & Shozae",
    trackInfo: "Grandmilly & Shozae - Fool's Gold",
    url: "https://www.youtube.com/watch?v=4WzGHCJmB8A",
  },
  {
    artist: "Automatic",
    trackInfo: "Automatic - Electrocution",
    url: "https://www.youtube.com/watch?v=U3jnK2xfjYM",
  },
  {
    artist: "Sudan Archives",
    trackInfo: "Sudan Archives - Glorious",
    url: "https://www.youtube.com/watch?v=BJDMSctOnQY",
  },
  {
    artist: "Automatic",
    trackInfo: "Automatic - Strange Conversations",
    url: "https://www.youtube.com/watch?v=gCZIhUbcz90",
  },
  {
    artist: "Sudan Archives",
    trackInfo: "Sudan Archives - Confessions",
    url: "https://www.youtube.com/watch?v=Zgjrt12QTVQ",
  },
  {
    artist: "Kiefer",
    trackInfo: "Be Encouraged: Kiefer Documentary",
    url: "https://www.youtube.com/watch?v=83joMCFE5gE",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - Golden - Superbloom",
    url: "https://www.youtube.com/watch?v=4tuvWY-wd0M",
  },
  {
    artist: "Peyton",
    trackInfo: "Peyton - laylo/crazy4U",
    url: "https://www.youtube.com/watch?v=8GTdjpMJ2k0",
  },
  {
    artist: "Automatic",
    trackInfo: "Automatic - Signal",
    url: "https://www.youtube.com/watch?v=gERLLTr5XlU",
  },
  {
    artist: "Jamael Dean",
    trackInfo: "Jamael Dean - People Tell Olo",
    url: "https://www.youtube.com/watch?v=rbNJnKsNvos",
  },
  {
    artist: "Jamael Dean",
    trackInfo: "Jamael Dean - Eledumare",
    url: "https://www.youtube.com/watch?v=ysf93bnoZKs",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - Be Encouraged",
    url: "https://www.youtube.com/watch?v=SL0fXKNAd2c",
  },
  {
    artist: "Benny Sings",
    trackInfo: "Dungeon Sessions: Benny Sings - Everything I Know",
    url: "https://www.youtube.com/watch?v=mGfQMtCePt4",
  },
  {
    artist: "Sudan Archives",
    trackInfo: "Sudan Archives - Confessions - Lyrics",
    url: "https://www.youtube.com/watch?v=xpuT86cv400",
  },
  {
    artist: "Automatic",
    trackInfo: "Automatic - Too Much Money",
    url: "https://www.youtube.com/watch?v=Ryh1pG3DFV4",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - May 20",
    url: "https://www.youtube.com/watch?v=Uu3KBCZQRIw",
  },
  {
    artist: "Jerry Paper",
    trackInfo: "Jerry Paper - Everything Borrowed",
    url: "https://www.youtube.com/watch?v=qwxx_fCjvYc",
  },
  {
    artist: "Blarf",
    trackInfo: "Blarf - Boom Ba",
    url: "https://www.youtube.com/watch?v=_TLTt0aqhG4",
  },
  {
    artist: "Benny Sings",
    trackInfo: "Benny Sings - Not Enough (Tux Reflux)",
    url: "https://www.youtube.com/watch?v=-3zfRO3xe6o",
  },
  {
    artist: "John Carroll Kirby",
    trackInfo: "John Carroll Kirby - Lazzara",
    url: "https://www.youtube.com/watch?v=Fdlb1Ypj8So",
  },
  {
    artist: "Automatic",
    trackInfo: "Automatic - Mind Your Own Business",
    url: "https://www.youtube.com/watch?v=cuY5L_HhBuk",
  },
  {
    artist: "Blarf",
    trackInfo: "Blarf - Banana",
    url: "https://www.youtube.com/watch?v=OZCiMMAcbfY",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - 10,000 Days",
    url: "https://www.youtube.com/watch?v=9A7fmEehmxY",
  },
  {
    artist: "Peyton",
    trackInfo: "Peyton - to spare",
    url: "https://www.youtube.com/watch?v=SbNp9XFsFNw",
  },
  {
    artist: "Rejoicer",
    trackInfo: "Dungeon Sessions: Rejoicer - Neo Drive Knows You",
    url: "https://www.youtube.com/watch?v=N9Wbc4I_7Aw",
  },
  {
    artist: "Automatic",
    trackInfo: "Automatic - Too Much Money",
    url: "https://www.youtube.com/watch?v=L1qXQXsKAy0",
  },
  {
    artist: "Automatic",
    trackInfo: "Automatic - Calling It",
    url: "https://www.youtube.com/watch?v=YKpbKcjVfTQ",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - Cute",
    url: "https://www.youtube.com/watch?v=Kaa9DkW_OvE",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - Orange Crayon",
    url: "https://www.youtube.com/watch?v=rswt16YNoZs",
  },
  {
    artist: "NxWorries",
    trackInfo: "NxWorries (Anderson.Paak & Knxwledge) - Lyk Dis",
    url: "https://www.youtube.com/watch?v=UJH5Dgf62Vk",
  },
  {
    artist: "Karriem Riggins",
    trackInfo: "Karriem Riggins - Bahia Dreamin'",
    url: "https://www.youtube.com/watch?v=jWWvvFSeXIg",
  },
  {
    artist: "Blarf",
    trackInfo: "Blarf - Badass Bullshit Benjamin Buttons Butthole Assassin",
    url: "https://www.youtube.com/watch?v=Adge5ZFtJ_Y",
  },
  {
    artist: "Los Retros",
    trackInfo: "Dungeon Sessions: Los Retros - Friends",
    url: "https://www.youtube.com/watch?v=uAuhytYUkN8",
  },
  {
    artist: "Los Retros",
    trackInfo: "Los Retros - Never Have Enough",
    url: "https://www.youtube.com/watch?v=E6LEg3Kg2nc",
  },
  {
    artist: "Automatic",
    trackInfo: "Automatic - Calling It",
    url: "https://www.youtube.com/watch?v=xyYJBmvM3DA",
  },
  {
    artist: "Mndsgn",
    trackInfo: "Mndsgn - Deviled Eggs - Snaxx",
    url: "https://www.youtube.com/watch?v=QDJ7-R7M2vQ",
  },
  {
    artist: "Los Retros",
    trackInfo: "Los Retros - Someone To Spend Time With",
    url: "https://www.youtube.com/watch?v=VRQDOFaFqWk",
  },
  {
    artist: "Los Retros",
    trackInfo: "Los Retros - Someone To Spend Time With",
    url: "https://www.youtube.com/watch?v=VRQDOFaFqWk",
  },
  {
    artist: "Benny Sings",
    trackInfo: "Benny Sings - Everything I Know",
    url: "https://www.youtube.com/watch?v=Ss0s60aoK6M",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - Sunny",
    url: "https://www.youtube.com/watch?v=9r4fDxpMvPg",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - Island",
    url: "https://www.youtube.com/watch?v=Ib28lr0whl8",
  },
  {
    artist: "Benny Sings",
    trackInfo: "Dungeon Sessions: Benny Sings - Not Enough",
    url: "https://www.youtube.com/watch?v=vnZJD5dhdcs",
  },
  {
    artist: "Jerry Paper",
    trackInfo: "Jerry Paper - My God Benedek Remix",
    url: "https://www.youtube.com/watch?v=xGIENDJa24M",
  },
  {
    artist: "Homeboy Sandman & Edan",
    trackInfo: "Homeboy Sandman & Edan - Unwavering Mind - Dungeon Sessions",
    url: "https://www.youtube.com/watch?v=SumCW7gqv0Y",
  },
  {
    artist: "Benny Sings",
    trackInfo: "Benny Sings - Not Enough",
    url: "https://www.youtube.com/watch?v=tm6x0q2INSs",
  },
  {
    artist: "Jerry Paper",
    trackInfo: "Jerry Paper - A Moment (Helado Negro Remix)",
    url: "https://www.youtube.com/watch?v=f54V0daA0gI",
  },
  {
    artist: "Rejoicer",
    trackInfo: "Rejoicer - Neo Drive",
    url: "https://www.youtube.com/watch?v=sNHcdBDb4VY",
  },
  {
    artist: "Jerry Paper",
    trackInfo: "Dungeon Sessions: Jerry Paper - Grey Area",
    url: "https://www.youtube.com/watch?v=j1r2RpWUn6E",
  },
  {
    artist: "Homeboy Sandman & Edan",
    trackInfo:
      "Dungeon Session: Homeboy Sandman & Edan - Rock & Roll Indian Dance",
    url: "https://www.youtube.com/watch?v=2rPoR9szRks",
  },
  {
    artist: "Rejoicer",
    trackInfo: "Rejoicer - Double Astral Move - Dungeon Sessions",
    url: "https://www.youtube.com/watch?v=7ChdblNiOjs",
  },
  {
    artist: "Benny Sings",
    trackInfo: "Benny Sings - Passionfruit",
    url: "https://www.youtube.com/watch?v=fp-jwwlhSug",
  },
  {
    artist: "Jerry Paper",
    trackInfo: "Jerry Paper - Grey Area",
    url: "https://www.youtube.com/watch?v=Dr9EwlaK-80",
  },
  {
    artist: "Homeboy Sandman & Edan",
    trackInfo: "Homeboy Sandman & Edan - The Gut",
    url: "https://www.youtube.com/watch?v=TQsOiRUhuko",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - What A Day",
    url: "https://www.youtube.com/watch?v=spyMOmC3K20",
  },
  {
    artist: "Stimulator Jones",
    trackInfo: "Stimulator Jones - Unsatisfied",
    url: "https://www.youtube.com/watch?v=VIMNRQzJtzw",
  },
  {
    artist: "Jerry Paper",
    trackInfo: "Jerry Paper - Your Cocoon - Dungeon Sessions",
    url: "https://www.youtube.com/watch?v=9y7K3Kja3qk",
  },
  {
    artist: "Rejoicer",
    trackInfo: "Rejoicer - Yesterday's Forest Magic feat. Sefi Zisling",
    url: "https://www.youtube.com/watch?v=1tjSeWFQ378",
  },
  {
    artist: "Homeboy Sandman & Edan",
    trackInfo: "Homeboy Sandman & Edan - NeverUseTheInternetAgain",
    url: "https://www.youtube.com/watch?v=Y4wOKLHi520",
  },
  {
    artist: "Jerry Paper",
    trackInfo: "Jerry Paper - My God",
    url: "https://www.youtube.com/watch?v=EpfGP_vY1Hw",
  },
  {
    artist: "The Steoples",
    trackInfo: "The Steoples - Best",
    url: "https://www.youtube.com/watch?v=fDvKogRdCCQ",
  },
  {
    artist: "Stimulator Jones",
    trackInfo: "Stimulator Jones - Give My All",
    url: "https://www.youtube.com/watch?v=m8KfOOpeMMM",
  },
  {
    artist: "Rejoicer",
    trackInfo: "Rejoicer - Purple T Shirts - feat. Mndsgn",
    url: "https://www.youtube.com/watch?v=NwIvqMw808o",
  },
  {
    artist: "Bryant K",
    trackInfo: "Bryant K - Dreams",
    url: "https://www.youtube.com/watch?v=3f0gJmwjwic",
  },
  {
    artist: "Jerry Paper",
    trackInfo: "Jerry Paper - Grey Area",
    url: "https://www.youtube.com/watch?v=CfjzNDD83eY",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - What a Day - Dungeon Sessions",
    url: "https://www.youtube.com/watch?v=OhqZh_c-9aI",
  },
  {
    artist: "Homeboy Sandman & Edan",
    trackInfo: "Homeboy Sandman & Edan - Grim Seasons",
    url: "https://www.youtube.com/watch?v=umff7Hael9k",
  },
  {
    artist: "Grandmilly & Shozae",
    trackInfo: "Grandmilly & Shozae - Cyber Tech Suits",
    url: "https://www.youtube.com/watch?v=70ZoqD10joI",
  },
  {
    artist: "Jerry Paper",
    trackInfo: "Jerry Paper - Your Cocoon",
    url: "https://www.youtube.com/watch?v=jzEKSTYa5FE",
  },
  {
    artist: "Grandmilly & Shozae",
    trackInfo: "Grandmilly & Shozae - Phillip Lim",
    url: "https://www.youtube.com/watch?v=PzKY3jVsb-o",
  },
  {
    artist: "Rejoicer",
    trackInfo: "Rejoicer - Double Astral Move",
    url: "https://www.youtube.com/watch?v=bCQL93BGm2Q",
  },
  {
    artist: "Prophet",
    trackInfo: "Prophet - Wanna Be Your Man",
    url: "https://www.youtube.com/watch?v=xUtV8TMGW6s",
  },
  {
    artist: "Sudan Archives",
    trackInfo: "Sudan Archives - Nont for Sale",
    url: "https://www.youtube.com/watch?v=3kRlBLPSgY8",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - AAAAA",
    url: "https://www.youtube.com/watch?v=ZIAADH9Ee8s",
  },
  {
    artist: "Stimulator Jones",
    trackInfo: "Stimulator Jones - Tempt Me With Your Love",
    url: "https://www.youtube.com/watch?v=PeTuhY65HUA",
  },
  {
    artist: "Prophet",
    trackInfo: "Prophet - Insanity",
    url: "https://www.youtube.com/watch?v=MCVXRB-j8DM",
  },
  {
    artist: "Grandmilly & Shozae",
    trackInfo: "Grandmilly & Shozae - Graffiti",
    url: "https://www.youtube.com/watch?v=DtA1ukwmKO4",
  },
  {
    artist: "Stimulator Jones",
    trackInfo: "Stimulator Jones - Give My All",
    url: "https://www.youtube.com/watch?v=0FDrG6C1Atw",
  },
  {
    artist: "Stimulator Jones",
    trackInfo: "Stimulator Jones - Soon Never Comes",
    url: "https://www.youtube.com/watch?v=jxhL-_FUBII",
  },
  {
    artist: "Sudan Archives",
    trackInfo: "Sudan Archives - Paid",
    url: "https://www.youtube.com/watch?v=cq1xvjix35Q",
  },
  {
    artist: "Stimulator Jones",
    trackInfo: "Stimulator Jones - Choosey Lover",
    url: "https://www.youtube.com/watch?v=5nqAFnOQiEk",
  },
  {
    artist: "The Steoples",
    trackInfo: "The Steoples - Smoak",
    url: "https://www.youtube.com/watch?v=rZyELAI7w5c",
  },
  {
    artist: "Jonti",
    trackInfo: "Jonti - Sleeping and Falling",
    url: "https://www.youtube.com/watch?v=HI4pq_Kb9fk",
  },
  {
    artist: "Jonti",
    trackInfo: "Jonti - Zuki",
    url: "https://www.youtube.com/watch?v=Yrk1VQ3i168",
  },
  {
    artist: "Karriem Riggins",
    trackInfo: "Karriem Riggins - Oddness",
    url: "https://www.youtube.com/watch?v=NJT8eczlmH8",
  },
  {
    artist: "Stimulator Jones",
    trackInfo: "Stimulator Jones - Need Your Body",
    url: "https://www.youtube.com/watch?v=MZKupBsK1NY",
  },
  {
    artist: "Jonti",
    trackInfo: "Jonti - Staring Window",
    url: "https://www.youtube.com/watch?v=62UoIqSyGSY",
  },
  {
    artist: "NxWorries",
    trackInfo: "NxWorries - Anderson Paak & Knxwledge - Best One Rmx",
    url: "https://www.youtube.com/watch?v=sqPb55lyvRs",
  },
  {
    artist: "Cohenbeats",
    trackInfo: "Cohenbeats feat. Quelle Chris - Daily Affirmations",
    url: "https://www.youtube.com/watch?v=BLkWspAj0q8",
  },
  {
    artist: "Sudan Archives",
    trackInfo: "Sudan Archives - Water",
    url: "https://www.youtube.com/watch?v=IEHau8sRX0A",
  },
  {
    artist: "Jonti",
    trackInfo: "Jonti - Sleeping and Falling",
    url: "https://www.youtube.com/watch?v=Omf2bX2CF5A",
  },
  {
    artist: "Cohenbeats",
    trackInfo: "Cohenbeats - Get Started",
    url: "https://www.youtube.com/watch?v=fvf-_pM-vJk",
  },
  {
    artist: "DJ Harrison",
    trackInfo: "DJ Harrison - Richmond Gospel",
    url: "https://www.youtube.com/watch?v=ui63X2hDirk",
  },
  {
    artist: "The Steoples",
    trackInfo: "The Steoples - Roles",
    url: "https://www.youtube.com/watch?v=cJXXl72Mopo",
  },
  {
    artist: "Sudan Archives",
    trackInfo: "Sudan Archives - Come Meh Way",
    url: "https://www.youtube.com/watch?v=KLPGMb35ubk",
  },
  {
    artist: "Washed Out",
    trackInfo: "Washed Out - The Mister Mellow Show",
    url: "https://www.youtube.com/watch?v=pZ5hH9bEnOk",
  },
  {
    artist: "Krondon & Shafiq Husayn",
    trackInfo: "Krondon & Shafiq Husayn - Mary's Son",
    url: "https://www.youtube.com/watch?v=tnQ3LRu88tQ",
  },
  {
    artist: "The Steoples",
    trackInfo: "The Steoples - From The Otherside",
    url: "https://www.youtube.com/watch?v=ym_jh6eqhv4",
  },
  {
    artist: "Washed Out",
    trackInfo: "Washed Out - Get Lost",
    url: "https://www.youtube.com/watch?v=xTjQHfP1KOo",
  },
  {
    artist: "Jonti",
    trackInfo: "Jonti - Rain (Live in the parking lot)",
    url: "https://www.youtube.com/watch?v=fdLl_k-jbtE",
  },
  {
    artist: "DJ Harrison",
    trackInfo: "DJ Harrison recording KalimbaTale at Jellowstone",
    url: "https://www.youtube.com/watch?v=CQbeLeO8xl8",
  },
  {
    artist: "Gabriel Garzón-Montano",
    trackInfo: "Gabriel Garzón-Montano - Fruitflies - Live in studio",
    url: "https://www.youtube.com/watch?v=_mLvSmlWtTQ",
  },
  {
    artist: "Kiefer",
    trackInfo: "Kiefer - Tubesocks - Kickinit Alone",
    url: "https://www.youtube.com/watch?v=vwj1QgJ3UAs",
  },
  {
    artist: "Tuxedo",
    trackInfo: "Tuxedo - Thank You 45",
    url: "https://www.youtube.com/watch?v=-qT9e4WMsJo",
  },
  {
    artist: "Gabriel Garzón-Montano",
    trackInfo: "Gabriel Garzón-Montano - My Balloon",
    url: "https://www.youtube.com/watch?v=rfKSZI3lrAE",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Bamboo",
    url: "https://www.youtube.com/watch?v=_op9htUP5r8",
  },
  {
    artist: "NxWorries",
    trackInfo: "NxWorries (Anderson .Paak & Knxwledge) - Scared Money",
    url: "https://www.youtube.com/watch?v=sHWFfF6faeA",
  },
  {
    artist: "Vex Ruffin",
    trackInfo: "Vex Ruffin - Front",
    url: "https://www.youtube.com/watch?v=kVxreWaT7nw",
  },
  {
    artist: "Jonti",
    trackInfo: "Jonti - Scrood (feat. Steve Lacy)",
    url: "https://www.youtube.com/watch?v=2FgoQJMOluw",
  },
  {
    artist: "DJ Harrison",
    trackInfo: "DJ Harrison – Rule the World",
    url: "https://www.youtube.com/watch?v=MKYIyTfxG5M",
  },
  {
    artist: "Gabriel Garzón-Montano",
    trackInfo: "Gabriel Garzón-Montano - The Game - Live in studio",
    url: "https://www.youtube.com/watch?v=t7Mxu9ffsk0",
  },
  {
    artist: "Sudan Archives",
    trackInfo: "Sudan Archives - Time",
    url: "https://www.youtube.com/watch?v=ebPvq6ebbdQ",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Clarity",
    url: "https://www.youtube.com/watch?v=LXnxpmBPwqo",
  },
  {
    artist: "Gabriel Garzón-Montano",
    trackInfo: "Gabriel Garzón-Montano – Crawl",
    url: "https://www.youtube.com/watch?v=9AT5eVEZLNA",
  },
  {
    artist: "NxWorries",
    trackInfo: "NxWorries - Anderson.Paak & Knxwledge - Sidepiece",
    url: "https://www.youtube.com/watch?v=sGkpY-tyGcM",
  },
  {
    artist: "Mndsgn",
    trackInfo: "Mndsgn - Lather (Live at Red Gate)",
    url: "https://www.youtube.com/watch?v=8a3xUSf6754",
  },
  {
    artist: "The Koreatown Oddity ",
    trackInfo: "The Koreatown Oddity - Yesterday's News",
    url: "https://www.youtube.com/watch?v=wuaRnRgN0Y8",
  },
  {
    artist: "Sudan Archives",
    trackInfo: "Sudan Archives - Queen Kunta",
    url: "https://www.youtube.com/watch?v=X4aPe8f7Sn4",
  },
  {
    artist: "Mndsgn",
    trackInfo: "Mndsgn - Alluptoyou",
    url: "https://www.youtube.com/watch?v=w5i0FFtFYCw",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Bus (A Rhyme)",
    url: "https://www.youtube.com/watch?v=__f95GJBj0s",
  },
  {
    artist: "Mild High Club",
    trackInfo: "Mild High Club - Kokopelli",
    url: "https://www.youtube.com/watch?v=RBiHYxZArgY",
  },
  {
    artist: "Mndsgn",
    trackInfo: "Mndsgn - Wherever U R",
    url: "https://www.youtube.com/watch?v=0kp-yEiQvSg",
  },
  {
    artist: "Vex Ruffin",
    trackInfo: "Vex Ruffin & Fab 5 Freddy – The Balance",
    url: "https://www.youtube.com/watch?v=0BzkUDjbXm4",
  },
  {
    artist: "Gabriel Garzón-Montano",
    trackInfo: "Gabriel Garzón-Montano - Trial",
    url: "https://www.youtube.com/watch?v=hlZCYZbBpIs",
  },
  {
    artist: "Deantoni Parks",
    trackInfo: "Dungeon Sessions: Deantoni Parks",
    url: "https://www.youtube.com/watch?v=UklNnGSvQMc",
  },
  {
    artist: "Mndsgn",
    trackInfo: "Mndsgn - Cosmic Perspective",
    url: "https://www.youtube.com/watch?v=BGgaZ66-hPA",
  },
  {
    artist: "Mild High Club",
    trackInfo: "Mild High Club - Skiptracing",
    url: "https://www.youtube.com/watch?v=n7SJM6o-RJ4",
  },
  {
    artist: "Frankie Reyes",
    trackInfo: "Frankie Reyes - La Comparsa - Boleros Valses y Mas",
    url: "https://www.youtube.com/watch?v=FXg0f0gsst0",
  },
  {
    artist: "Koreatown Oddity",
    trackInfo: "Koreatown Oddity - Fuck Dinosaurs",
    url: "https://www.youtube.com/watch?v=-QN6gtU0I9g",
  },
  {
    artist: "Frankie Reyes",
    trackInfo: "In the Stones Throw dungeon with Frankie Reyes & crew (360°)",
    url: "https://www.youtube.com/watch?v=2GnA_dIb0eo",
  },
  {
    artist: "Samiyam",
    trackInfo: "Samiyam - Earl Sweatshirt - Mirror",
    url: "https://www.youtube.com/watch?v=dwZcuwfiCjE",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Eyes",
    url: "https://www.youtube.com/watch?v=qkg-OMDiyG4",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Nonbelievers",
    url: "https://www.youtube.com/watch?v=qTEgpkCxpuo",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Dungeon Sessions: Homeboy Sandman - God",
    url: "https://www.youtube.com/watch?v=4dNtT93Ts18",
  },
  {
    artist: "Carlos Niño",
    trackInfo: "Dungeon Sessions: Carlos Niño & Friends “It’s All Happening!”",
    url: "https://www.youtube.com/watch?v=uTvXYm4JVP8",
  },
  {
    artist: "EGYPTIAN LOVER",
    trackInfo: "EGYPTIAN LOVER 🌴 I CRY (NIGHT AFTER NIGHT)🌴",
    url: "https://www.youtube.com/watch?v=2BNUV9SiEVg",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Talking (Bleep)",
    url: "https://www.youtube.com/watch?v=xgsossmuDXA",
  },
  {
    artist: "Mndsgn",
    trackInfo: "Dungeon Sessions: Mndsgn - Camelblues",
    url: "https://www.youtube.com/watch?v=qpYth7TD4Ak",
  },
  {
    artist: "EGYPTIAN LOVER",
    trackInfo: "EGYPTIAN LOVER - ∆∆∆🌴NILEVISION🌴∆∆∆",
    url: "https://www.youtube.com/watch?v=PFnQ3LHG3VA",
  },
  {
    artist: "Samiyam",
    trackInfo: "Dungeon sessions: Samiyam (360°)",
    url: "https://www.youtube.com/watch?v=wshb1-ZI5cM",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Life Support",
    url: "https://www.youtube.com/watch?v=OCG8YJ55kT0",
  },
  {
    artist: "NxWorries",
    trackInfo: "NxWorries (Anderson .Paak & Knxwledge) - Link Up",
    url: "https://www.youtube.com/watch?v=PsXaSRBO5kM",
  },
  {
    artist: "Krondon & Shafiq Husayn",
    trackInfo:
      "Krondon & Shafiq Husayn - G.U.N. (God Understand Niguhs), feat. Chace Infinite",
    url: "https://www.youtube.com/watch?v=2wP41modFCo",
  },
  {
    artist: "Karriem Riggins",
    trackInfo: "Dungeon sessions: Karriem Riggins & J Rocc (360°)",
    url: "https://www.youtube.com/watch?v=jJyFAn_QQFg",
  },
  {
    artist: "Mndsgn & Nanna B.",
    trackInfo: "Mndsgn & Nanna B. - Akasha",
    url: "https://www.youtube.com/watch?v=f3_QBK2nUVI",
  },
  {
    artist: "Mild High Club",
    trackInfo: "Mild High Club - Rollercoaster Baby",
    url: "https://www.youtube.com/watch?v=mM74Twj96tk",
  },
  {
    artist: "NxWorries",
    trackInfo:
      "Dungeon sessions: Link Up by NxWorries (Anderson.Paak & Knxwledge)",
    url: "https://www.youtube.com/watch?v=Yu08TQWuups",
  },
  {
    artist: "Natural Numbers",
    trackInfo: "Natural Numbers - Dub Of Shadows",
    url: "https://www.youtube.com/watch?v=K3Ey3CdodKs",
  },
  {
    artist: "Krondon & Shafiq Husayn",
    trackInfo: "Krondon & Shafiq Husayn – Main St",
    url: "https://www.youtube.com/watch?v=06VW3rMK6HE",
  },
  {
    artist: "Krondon & Shafiq Husayn",
    trackInfo: "Dungeon Sessions: Krondon & Shafiq Husayn",
    url: "https://www.youtube.com/watch?v=omuq16sDYL0",
  },
  {
    artist: "The Lions",
    trackInfo: "The Lions - The Magnificent Dance, feat. Black Shakespeare",
    url: "https://www.youtube.com/watch?v=Llb7g_rGMoI",
  },
  {
    artist: "Guilty Simpson",
    trackInfo: "Guilty Simpson - The D",
    url: "https://www.youtube.com/watch?v=i2sbtJ1JDsY",
  },
  {
    artist: "Jesse Hackett",
    trackInfo: "Jesse Hackett - The Dump Run",
    url: "https://www.youtube.com/watch?v=LX-0avQOH2I",
  },
  {
    artist: "Mild High Club",
    trackInfo: "Mild High Club - Undeniable",
    url: "https://www.youtube.com/watch?v=H13tgwE4VUw",
  },
  {
    artist: "Krondon & Shafiq Husayn",
    trackInfo: "Krondon & Shafiq Husayn – Mothership Intro",
    url: "https://www.youtube.com/watch?v=lQsbQUxLlbI",
  },
  {
    artist: "Diva",
    trackInfo: "Diva - Divinity in Thee",
    url: "https://www.youtube.com/watch?v=Qfwssqm2uVA",
  },
  {
    artist: "NxWorries",
    trackInfo: "NxWorries (Anderson.Paak & Knxwledge) - Suede",
    url: "https://www.youtube.com/watch?v=zNTNbNtft9g",
  },
  {
    artist: "Dam-Funk",
    trackInfo: "Dam-Funk - We Continue",
    url: "https://www.youtube.com/watch?v=LEu_ARi0Fc8",
  },
  {
    artist: "Knxwledge",
    trackInfo: "Knxwledge - Flyinglizrds",
    url: "https://www.youtube.com/watch?v=vjUr5-_8xmU",
  },
  {
    artist: "James Pants",
    trackInfo: "James Pants - Mechanique",
    url: "https://www.youtube.com/watch?v=f35elPDQbE0",
  },
  {
    artist: "Knxwledge",
    trackInfo: "Dungeon sessions: Knxwledge - Jstowee",
    url: "https://www.youtube.com/watch?v=yK91vjg2Hsg",
  },
  {
    artist: "Dam-Funk",
    trackInfo: "Dam-Funk - When I'm With U I Think of Her (Adolescent Funk)",
    url: "https://www.youtube.com/watch?v=GWIhIAcuSXA",
  },
  {
    artist: "James Pants",
    trackInfo: "James Pants - Artificial Lover",
    url: "https://www.youtube.com/watch?v=qhUi7INm0DM",
  },
  {
    artist: "The Lions",
    trackInfo: "Dungeon Sessions: The Lions - When It Rains",
    url: "https://www.youtube.com/watch?v=GVxjswGyvXM",
  },
  {
    artist: "Mild High Club",
    trackInfo: "Mild High Club - Windowpane",
    url: "https://www.youtube.com/watch?v=jEX0r9cs5_0",
  },
  {
    artist: "James Pants",
    trackInfo: "James Pants - Broth",
    url: "https://www.youtube.com/watch?v=KAUyPTDFO9Y",
  },
  {
    artist: "Mild High Club",
    trackInfo: "Dungeon Sessions: Mild High Club - Weeping Willow",
    url: "https://www.youtube.com/watch?v=M5sNpJgpZkU",
  },
  {
    artist: "NxWorries",
    trackInfo:
      "Dungeon Sessions: NxWorries - Anderson.Paak & Knxwledge - Suede",
    url: "https://www.youtube.com/watch?v=WGIWLiO5058",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - America the Beautiful",
    url: "https://www.youtube.com/watch?v=j_56QEKDtHE",
  },
  {
    artist: "Pyramid Vritra",
    trackInfo: "Pyramid Vritra - Like Summer",
    url: "https://www.youtube.com/watch?v=LPhA3yucb-E",
  },
  {
    artist: "Mndsgn",
    trackInfo: "Mndsgn – Frugality, Zen & Homewards",
    url: "https://www.youtube.com/watch?v=j8FhQYMKnpo",
  },
  {
    artist: "Silk Rhodes",
    trackInfo: "Silk Rhodes - Pains",
    url: "https://www.youtube.com/watch?v=SoxbvE1Doog",
  },
  {
    artist: "Mndsgn",
    trackInfo: "Mndsgn - Camelblues",
    url: "https://www.youtube.com/watch?v=h_ZKRFxxFU0",
  },
  {
    artist: "Pyramid Vritra",
    trackInfo: "Pyramid Vritra - Palace",
    url: "https://www.youtube.com/watch?v=vNy_7tXTgVc",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Refugee",
    url: "https://www.youtube.com/watch?v=DWZb3RBYZs8",
  },
  {
    artist: "Mndsgn",
    trackInfo: "Mndsgn - Sheets",
    url: "https://www.youtube.com/watch?v=8oQGWJ3CwBM",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Problems",
    url: "https://www.youtube.com/watch?v=prBsyiMki2k",
  },
  {
    artist: "Mndsgn",
    trackInfo: "Mndsgn - TXT MSGS",
    url: "https://www.youtube.com/watch?v=BOtcIGgYp-M",
  },
  {
    artist: "Pyramid Vritra",
    trackInfo: "Pyramid Vritra - 224 feat. Huey Briss",
    url: "https://www.youtube.com/watch?v=QGmsfioDyxU",
  },
  {
    artist: "Myron & E",
    trackInfo: "Myron & E - Broadway",
    url: "https://www.youtube.com/watch?v=ru15UfqheMM",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Supervillain Theme - Madvillainy",
    url: "https://www.youtube.com/watch?v=Qx2zU1c2LFM",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Eye - Madvillainy",
    url: "https://www.youtube.com/watch?v=IbGLhsf1iLQ",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Hardcore Hustle feat. Wildchild - Madvillainy",
    url: "https://www.youtube.com/watch?v=EjJmf6ukHG4",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Figaro - Madvillainy",
    url: "https://www.youtube.com/watch?v=A7_0vcjN-4c",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Operation Lifesaver - Madvillainy",
    url: "https://www.youtube.com/watch?v=3CCZtfZidtw",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Shadows of Tomorrow feat. Quasimoto - Madvillainy",
    url: "https://www.youtube.com/watch?v=PuaVf4f6lBM",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Money Folder - Madvillainy",
    url: "https://www.youtube.com/watch?v=okYZpiuvQi4",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Do Not Fire! - Madvillainy",
    url: "https://www.youtube.com/watch?v=iA2_XNCcygE",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Curls - Madvillainy",
    url: "https://www.youtube.com/watch?v=herNYSdJd0o",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Rainbows - Madvillainy",
    url: "https://www.youtube.com/watch?v=yDpaCiXJTEk",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Sickfit - Madvillainy",
    url: "https://www.youtube.com/watch?v=BTPRlerb1zQ",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - America's Most Blunted - Madvillainy",
    url: "https://www.youtube.com/watch?v=KU7r89OoAho",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Bistro - Madvillainy",
    url: "https://www.youtube.com/watch?v=PRRMPtkmJjA",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Meat Grinder - Madvillainy",
    url: "https://www.youtube.com/watch?v=x8Ru8d0l_fU",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - The Illest Villains - Madvillainy",
    url: "https://www.youtube.com/watch?v=zQ0yXh_ADlQ",
  },
  {
    artist: "Pyramid Vritra",
    trackInfo: "Pyramid Vritra - Eleven12",
    url: "https://www.youtube.com/watch?v=FHe9AZ0MwHA",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Stop - Donuts",
    url: "https://www.youtube.com/watch?v=Ek_cufWYvjE",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - The New - Donuts",
    url: "https://www.youtube.com/watch?v=0piaF7P3404",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - One Eleven - Donuts",
    url: "https://www.youtube.com/watch?v=TEPCiR3lidM",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - One for Ghost - Donuts",
    url: "https://www.youtube.com/watch?v=1QWY7CBNrgM",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Airworks - Donuts",
    url: "https://www.youtube.com/watch?v=HWz-yEZ6wNY",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - The Factory - Donuts",
    url: "https://www.youtube.com/watch?v=TVdIkN6qT6g",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Walkinonit - Donuts",
    url: "https://www.youtube.com/watch?v=odUauxvoNwQ",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Mash - Donuts",
    url: "https://www.youtube.com/watch?v=ZLa6sX9N3Jw",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Dilla Says Go - Donuts",
    url: "https://www.youtube.com/watch?v=RrCECnzWCDM",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Glazed - Donuts",
    url: "https://www.youtube.com/watch?v=eYhHyUU-CYU",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Bye - Donuts",
    url: "https://www.youtube.com/watch?v=2-hKtCCgIMw",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Thunder - Donuts",
    url: "https://www.youtube.com/watch?v=pZoOyP013Hc",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Waves - Donuts",
    url: "https://www.youtube.com/watch?v=vykkfDITkQs",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Welcome to the Show - Donuts",
    url: "https://www.youtube.com/watch?v=4tAsNON4SN0",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Lightworks- Donuts",
    url: "https://www.youtube.com/watch?v=Bul7m3jN25Q",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Gobstopper - Donuts",
    url: "https://www.youtube.com/watch?v=atPXB02SLaw",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - The Diff'rence - Donuts",
    url: "https://www.youtube.com/watch?v=v2zTVZFlCZ0",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - People - Donuts",
    url: "https://www.youtube.com/watch?v=zNJJBD_I5EU",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Workinonit - Donuts",
    url: "https://www.youtube.com/watch?v=5nO7IA1DeeI",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Hi - Donuts",
    url: "https://www.youtube.com/watch?v=uJj3UJkyiKg",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Time: The Donut of the Heart - Donuts",
    url: "https://www.youtube.com/watch?v=c6qOBFkvdG0",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Stepson of the Clapper - Donuts",
    url: "https://www.youtube.com/watch?v=Epab732wJWU",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - The Twister (Huh,What) - Donuts",
    url: "https://www.youtube.com/watch?v=6K7u4WJRXgY",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Don't Cry",
    url: "https://www.youtube.com/watch?v=NHn-G_YpQB0",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Fat Belly",
    url: "https://www.youtube.com/watch?v=S1lsX4-DL2Q",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman & Paul White",
    url: "https://www.youtube.com/watch?v=V0ekf6Q-aXE",
  },
  {
    artist: "Pyramid Vritra",
    trackInfo: "Pyramid Vritra - Spool",
    url: "https://www.youtube.com/watch?v=N37oWUBC-2M",
  },
  {
    artist: "7 Days of Funk",
    trackInfo:
      "7 Days of Funk - Snoop & Dam-Funk - High Wit Me (Fourth Runner Up)",
    url: "https://www.youtube.com/watch?v=fl6pnxig-S0",
  },
  {
    artist: "The Stepkids",
    trackInfo: "The Stepkids - Insecure Troubadour",
    url: "https://www.youtube.com/watch?v=0BTGIjZhUt0",
  },
  {
    artist: "7 Days of Funk",
    trackInfo: "7 Days of Funk - Snoop & Dam-Funk - High Wit Me",
    url: "https://www.youtube.com/watch?v=g-_TLRBlIp8",
  },
  {
    artist: "7 Days of Funk",
    trackInfo: "7 Days Of Funk - High Wit Me (First Runner Up)",
    url: "https://www.youtube.com/watch?v=jRzcyKC9-Y0",
  },
  {
    artist: "7 Days of Funk",
    trackInfo:
      "7 Days of Funk - Snoop & Dam-Funk - High Wit Me (Second Runner Up)",
    url: "https://www.youtube.com/watch?v=-MYwaXJUGMQ",
  },
  {
    artist: "7 Days of Funk",
    trackInfo:
      "7 Days of Funk - Snoop & Dam-Funk - High Wit Me (Third Runner Up)",
    url: "https://www.youtube.com/watch?v=NEinr64SlWw",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Bad Meaning Good",
    url: "https://www.youtube.com/watch?v=Rf8QxMpKAM4",
  },
  {
    artist: "Jonwayne",
    trackInfo: "Jonwayne - How to Be a Gemini",
    url: "https://www.youtube.com/watch?v=-oC8r7a-DdE",
  },
  {
    artist: "The Stepkids",
    trackInfo: "The Stepkids - Art of Forgetting",
    url: "https://www.youtube.com/watch?v=jXgLUNGUNuc",
  },
  {
    artist: "Pyramid Vritra",
    trackInfo: "Pyramid Vritra - Tea And Lemonade",
    url: "https://www.youtube.com/watch?v=VMCPNiv2nsY",
  },
  {
    artist: "7 Days of Funk",
    trackInfo: "7 Days of Funk - Dam Funk & Snoopzilla - I'll Be There 4U",
    url: "https://www.youtube.com/watch?v=V8qeincu7Qk",
  },
  {
    artist: "Duppy Gun",
    trackInfo: "Duppy Gun - G Sudden and Bookfa in Jamaica",
    url: "https://www.youtube.com/watch?v=TPVR0B42b9I",
  },
  {
    artist: "Jonwayne",
    trackInfo: "Jonwayne - The Come Up - ft. Scoop DeVille",
    url: "https://www.youtube.com/watch?v=9P9pw3kawpw",
  },
  {
    artist: "Jonwayne",
    trackInfo: "Jonwayne - The Come Up PT. 2 - Live at Low End Theory",
    url: "https://www.youtube.com/watch?v=CI2BdeYnUuc",
  },
  {
    artist: "Dub Club",
    trackInfo: "Little Harry - Revolution - Dub Club",
    url: "https://www.youtube.com/watch?v=f0bGjRfcY7Y",
  },
  {
    artist: "7 Days of Funk",
    trackInfo: "7 Days of Funk - Dam-Funk & Snoop - Faden Away",
    url: "https://www.youtube.com/watch?v=MHo3HwUb5D0",
  },
  {
    artist: "Duppy Gun",
    trackInfo: "Duppy Gun on Recording in Jamaica",
    url: "https://www.youtube.com/watch?v=2m-I9Bh7m6Y",
  },
  {
    artist: "7 Days of Funk",
    trackInfo: "7 Days of Funk - D-F & Snoopzilla",
    url: "https://www.youtube.com/watch?v=_boLyAb8WNw",
  },
  {
    artist: "Jonwayne",
    trackInfo: "Jonwayne - Curious (Cassette 2)",
    url: "https://www.youtube.com/watch?v=rAKwAHgTZMY",
  },
  {
    artist: "Vex Ruffin",
    trackInfo: "Vex Ruffin - Living For The Future",
    url: "https://www.youtube.com/watch?v=FF2mXffrKP8",
  },
  {
    artist: "Boardwalk",
    trackInfo: "Boardwalk - High Water",
    url: "https://www.youtube.com/watch?v=EaRukQ3g8gw",
  },
  {
    artist: "The Stepkids",
    trackInfo: "The Stepkids - Moving Pictures",
    url: "https://www.youtube.com/watch?v=h8SyClHeRa4",
  },
  {
    artist: "Dub Club",
    trackInfo: "Prince Jazzbo - Black Shadow - Dub Club",
    url: "https://www.youtube.com/watch?v=EMRhP8qsMPk",
  },
  {
    artist: "Anika",
    trackInfo: "Anika - In The City",
    url: "https://www.youtube.com/watch?v=AiOTP2RpvDg",
  },
  {
    artist: "Myron & E",
    trackInfo: "Myron & E - Do It Do It Disco",
    url: "https://www.youtube.com/watch?v=PdlRxByX56s",
  },
  {
    artist: "Quasimoto",
    trackInfo: "Quasimoto - Catchin' The Vibe",
    url: "https://www.youtube.com/watch?v=TVbrpJ13emo",
  },
  {
    artist: "Myron & E",
    trackInfo: "Myron & E - Cold Game (Live In Studio)",
    url: "https://www.youtube.com/watch?v=tUddsLpG7wA",
  },
  {
    artist: "CX KIDTRONIK",
    trackInfo: "CX KIDTRONIK - A WEAPON",
    url: "https://www.youtube.com/watch?v=LJltNK-qBlA",
  },
  {
    artist: "Dub Club",
    trackInfo: "JOSEY WALES - HARD TIME - Dub Club",
    url: "https://www.youtube.com/watch?v=FS0i32-OaI0",
  },
  {
    artist: "Myron & E",
    trackInfo: "Myron & E - On Broadway",
    url: "https://www.youtube.com/watch?v=WCiF-ndqXv8",
  },
  {
    artist: "Dub Club",
    trackInfo: "TIPPA LEE - MR. BIG MAN - Dub Club",
    url: "https://www.youtube.com/watch?v=-6fzMfVl9EE",
  },
  {
    artist: "CX KIDTRONIK",
    trackInfo: "CX KiDTRONiK - LET'S GO KRAZY (Atari Teenage Riot Mix)",
    url: "https://www.youtube.com/watch?v=TdzFl8oq08M",
  },
  {
    artist: "Myron & E",
    trackInfo: "Myron & E - If I Gave You My Love",
    url: "https://www.youtube.com/watch?v=NJOIELtziPk",
  },
  {
    artist: "Quasimoto",
    trackInfo: "Quasimoto - Planned Attack",
    url: "https://www.youtube.com/watch?v=_0sPtj57inQ",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Peace & Love",
    url: "https://www.youtube.com/watch?v=wYbtv_uBXEE",
  },
  {
    artist: "Anika",
    trackInfo: "Anika - I Go To Sleep",
    url: "https://www.youtube.com/watch?v=nohvkBvkKRs",
  },
  {
    artist: "The Lions",
    trackInfo: "The Lions - Roll It Round",
    url: "https://www.youtube.com/watch?v=lbeDY7BIvgY",
  },
  {
    artist: "Chrome Canyon",
    trackInfo: "Chrome Canyon - Generations",
    url: "https://www.youtube.com/watch?v=j_k2rAOAMnk",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Couple Bars",
    url: "https://www.youtube.com/watch?v=WxY9et9V9Bo",
  },
  {
    artist: "Julian Malone",
    trackInfo: "Julian Malone - 7Milli",
    url: "https://www.youtube.com/watch?v=8T2kgeiNP48",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Two Can Win",
    url: "https://www.youtube.com/watch?v=jMu47CsLm0M",
  },
  {
    artist: "Karriem Riggins",
    trackInfo: "Karriem Riggins - Round The Outside (Alone Together)",
    url: "https://www.youtube.com/watch?v=gaVhHlO0Dxo",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - VerbalSoulClapMania",
    url: "https://www.youtube.com/watch?v=3Bk_Ai17dYU",
  },
  {
    artist: "Chrome Canyon",
    trackInfo: "Chrome Canyon - Pluze",
    url: "https://www.youtube.com/watch?v=D0c5meGhSGA",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Illuminati",
    url: "https://www.youtube.com/watch?v=EsNfgRrtzos",
  },
  {
    artist: "Karriem Riggins",
    trackInfo: "Karriem Riggins - Summer Madness",
    url: "https://www.youtube.com/watch?v=MYciNjzMj_Q",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Sputnik",
    url: "https://www.youtube.com/watch?v=cLqiRXg6X1U",
  },
  {
    artist: "Jonti",
    trackInfo: "Jonti - Saturday Night",
    url: "https://www.youtube.com/watch?v=8ylcJjlCnTE",
  },
  {
    artist: "The Lions",
    trackInfo: "The Lions - This Generation",
    url: "https://www.youtube.com/watch?v=-jtU1vOktSY",
  },
  {
    artist: "Vex Ruffin",
    trackInfo: "Vex Ruffin - Crash Course",
    url: "https://www.youtube.com/watch?v=nLiZT7Aauf8",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Whatchu Want From Me",
    url: "https://www.youtube.com/watch?v=jPYDGNEYr1k",
  },
  {
    artist: "The Stepkids",
    trackInfo: "The Stepkids - Sweet Salvation",
    url: "https://www.youtube.com/watch?v=N-E3NE6XGQ4",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Not Really",
    url: "https://www.youtube.com/watch?v=yhe-eYHQgXA",
  },
  {
    artist: "Dam-Funk",
    trackInfo: "Dam-Funk - I Don't Wanna Be A Star!",
    url: "https://www.youtube.com/watch?v=NjffUs1HbrI",
  },
  {
    artist: "Chrome Canyon",
    trackInfo: "Chrome Canyon - Branches",
    url: "https://www.youtube.com/watch?v=16As-IqKSuQ",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman: FOUNDATION Pt. 2",
    url: "https://www.youtube.com/watch?v=avRw-3aU3EQ",
  },
  {
    artist: "Strong Arm Steady",
    trackInfo: "Strong Arm Steady - Classic",
    url: "https://www.youtube.com/watch?v=279XK6zws54",
  },
  {
    artist: "Chrome Canyon",
    trackInfo: "Chrome Canyon - Memories of a Scientist",
    url: "https://www.youtube.com/watch?v=HMcz1Cva5vk",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman: FOUNDATION Pt. 1",
    url: "https://www.youtube.com/watch?v=aQlM99HNL80",
  },
  {
    artist: "Strong Arm Steady & Statik Selektah",
    trackInfo: "Strong Arm Steady & Statik Selektah - Premium",
    url: "https://www.youtube.com/watch?v=rEdpMk5F0HA",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - I Do Whatever I Want",
    url: "https://www.youtube.com/watch?v=FrJluVLDxNw",
  },
  {
    artist: "Jonti",
    trackInfo: "Jonti - Nightshift In Blue",
    url: "https://www.youtube.com/watch?v=_MJNjRAkRfE",
  },
  {
    artist: "Dave Dub",
    trackInfo: "Dave Dub - Superfly",
    url: "https://www.youtube.com/watch?v=GdvY3uq7RIY",
  },
  {
    artist: "Quakers",
    trackInfo: "Quakers - Fitta Happier",
    url: "https://www.youtube.com/watch?v=oNb7DwiklZg",
  },
  {
    artist: "Quakers",
    trackInfo: "Quakers - Smoke feat. Jonwayne",
    url: "https://www.youtube.com/watch?v=d3EhoaHo-sM",
  },
  {
    artist: "M.E.D.",
    trackInfo: "M.E.D. feat. Hodgy Beats - Outta Control",
    url: "https://www.youtube.com/watch?v=hFowz5b5GLM",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Hold Your Head",
    url: "https://www.youtube.com/watch?v=UNyLT_quNVo",
  },
  {
    artist: "Gary Wilson",
    trackInfo: "Gary Wilson - Music For Drums (1994)",
    url: "https://www.youtube.com/watch?v=li7WxOjuKHo",
  },
  {
    artist: "Quakers",
    trackInfo: "Quakers - Russia with Love",
    url: "https://www.youtube.com/watch?v=J5R4T0yW5_4",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - Mine All Mine",
    url: "https://www.youtube.com/watch?v=9U-HK9d_CzA",
  },
  {
    artist: "Homeboy Sandman",
    trackInfo: "Homeboy Sandman - The Miracle",
    url: "https://www.youtube.com/watch?v=7xZcXEbU_Uw",
  },
  {
    artist: "Aloe Blacc",
    trackInfo: "Aloe Blacc - You Make Me Smile",
    url: "https://www.youtube.com/watch?v=0j3em6RhvnQ",
  },
  {
    artist: "Tony Cook",
    trackInfo: "Tony Cook feat. Dam Funk - What's On Your Mind?",
    url: "https://www.youtube.com/watch?v=DITCEPF5IHk",
  },
  {
    artist: "The Stepkids",
    trackInfo: "The Stepkids - Shadows On Behalf",
    url: "https://www.youtube.com/watch?v=I4R7XzpOhCw",
  },
  {
    artist: "M.E.D.",
    trackInfo: "M.E.D. - War & Love, feat. Oh No",
    url: "https://www.youtube.com/watch?v=6idlGXj7BD4",
  },
  {
    artist: "The Stepkids",
    trackInfo: "The Stepkids - Suburban Dream",
    url: "https://www.youtube.com/watch?v=DwvA4t6NBak",
  },
  {
    artist: "Vex Ruffin",
    trackInfo: "Vex Ruffin - Man With A Plan",
    url: "https://www.youtube.com/watch?v=oviOmyVGeNM",
  },
  {
    artist: "Dam-Funk",
    trackInfo:
      "Dam-Funk & Master Blazter Live at Stones Throw's Direct to Disc #3",
    url: "https://www.youtube.com/watch?v=ip83JHvzLBc",
  },
  {
    artist: "Gary Wilson",
    trackInfo: "Gary Wilson - Music For Piano (1994)",
    url: "https://www.youtube.com/watch?v=7W1Kh_yaoBw",
  },
  {
    artist: "M.E.D.",
    trackInfo: "M.E.D. - Blaxican",
    url: "https://www.youtube.com/watch?v=X0RvPfxRPig",
  },
  {
    artist: "Jonti",
    trackInfo: "Dungeon Sessions: Jonti - Hornet's Nest",
    url: "https://www.youtube.com/watch?v=anXc6WwK1bY",
  },
  {
    artist: "Anika",
    trackInfo: "Anika - Terry",
    url: "https://www.youtube.com/watch?v=a8Kd6cgBatg",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - U-Love (Donuts)",
    url: "https://www.youtube.com/watch?v=zwTyR6_kLjY",
  },
  {
    artist: "Vex Ruffin",
    trackInfo: "Vex Ruffin - I'm Creative",
    url: "https://www.youtube.com/watch?v=aSs4oPgPcPg",
  },
  {
    artist: "Aloe Blacc",
    trackInfo: "Aloe Blacc - Green Lights",
    url: "https://www.youtube.com/watch?v=9fbxTFevdAE",
  },
  {
    artist: "Quasimoto",
    trackInfo: "Quasimoto - Low Class Conspiracy",
    url: "https://www.youtube.com/watch?v=Z73FthAvt34",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Last Donut of the Night",
    url: "https://www.youtube.com/watch?v=fC3Cthm0HFU",
  },
  {
    artist: "Jaylib",
    trackInfo: "Jaylib - The Heist",
    url: "https://www.youtube.com/watch?v=XuVCHQjsQ0g",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Strange Ways",
    url: "https://www.youtube.com/watch?v=uSxlZQUqVPY",
  },
  {
    artist: "Quasimoto",
    trackInfo: "Quasimoto - Bus Ride",
    url: "https://www.youtube.com/watch?v=3S6Bgqaqv-o",
  },
  {
    artist: "James Pants",
    trackInfo: "James Pants - Clouds Over The Pacific",
    url: "https://www.youtube.com/watch?v=BUWq_hzKB0U",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Fancy Clown",
    url: "https://www.youtube.com/watch?v=IeqpRI5p5dI",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Lightworks",
    url: "https://www.youtube.com/watch?v=xLf6hzkeXbg",
  },
  {
    artist: "James Pants",
    trackInfo: "James Pants - The Occult (Jean-Pierre Caner)",
    url: "https://www.youtube.com/watch?v=WsATvPmsZn4",
  },
  {
    artist: "Madlib",
    trackInfo: "Madlib - Falling (Jovan Jimenez)",
    url: "https://www.youtube.com/watch?v=Uz_X3dIa1ho",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Fancy Clown",
    url: "https://www.youtube.com/watch?v=NYpXwlGT7XE",
  },
  {
    artist: "Koushik",
    trackInfo: "Koushik - Morning Comes (Niko/Calor Films)",
    url: "https://www.youtube.com/watch?v=lzPNUY-DqgE",
  },
  {
    artist: "Gary Wilson",
    trackInfo: "Gary Wilson - Electric Depression (Alex Saylor)",
    url: "https://www.youtube.com/watch?v=gLtTKGkSakQ",
  },
  {
    artist: "CX KIDTRONIK",
    trackInfo: "CX KIDTRONIK - SHE'S A MURDERER",
    url: "https://www.youtube.com/watch?v=V0deRfGvd54",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Geek Down",
    url: "https://www.youtube.com/watch?v=70SwRaTFgHM",
  },
  {
    artist: "The Stepkids",
    trackInfo: "The Stepkids - Live at Direct to Disc #2",
    url: "https://www.youtube.com/watch?v=kb6H7KfgXs0",
  },
  {
    artist: "Gary WIlson",
    trackInfo:
      "Gary WIlson - Linda Wants to Be Alone (Live at Direct to Disc #2)",
    url: "https://www.youtube.com/watch?v=G1rZuSGcd-Q",
  },
  {
    artist: "The Stepkids",
    trackInfo: "The Stepkids - Wonderfox",
    url: "https://www.youtube.com/watch?v=1rAHVkEeC-4",
  },
  {
    artist: "Anika",
    trackInfo: "Anika - No One's There",
    url: "https://www.youtube.com/watch?v=UgCuK0hLQ5Q",
  },
  {
    artist: "J Rocc",
    trackInfo: "J.Rocc - Play This Also",
    url: "https://www.youtube.com/watch?v=Zeoe-nhqyWU",
  },
  {
    artist: "Vex Ruffin",
    trackInfo: "Vex Ruffin - Losing Control",
    url: "https://www.youtube.com/watch?v=NQWntkvYmmw",
  },
  {
    artist: "Jonti",
    trackInfo: "Jonti - Firework Spraying Moon",
    url: "https://www.youtube.com/watch?v=GHfs8s-gjcg",
  },
  {
    artist: "Bryant K",
    trackInfo: "Bryant K - Daisies Grow",
    url: "https://www.youtube.com/watch?v=KamqxWtwzgU",
  },
  {
    artist: "J Rocc",
    trackInfo: "J Rocc - Stay Fresh",
    url: "https://www.youtube.com/watch?v=qTc0r5L8DM4",
  },
  {
    artist: "Aloe Blacc",
    trackInfo: "Aloe Blacc - Loving You Is Killing Me",
    url: "https://www.youtube.com/watch?v=_yJuyaVcL2I",
  },
  {
    artist: "Aloe Blacc",
    trackInfo: "Aloe Blacc - Studio Take Outs",
    url: "https://www.youtube.com/watch?v=aKyiPloOQHc",
  },
  {
    artist: "Anika",
    trackInfo: "Anika Rehearsal",
    url: "https://www.youtube.com/watch?v=-RKD8CCVIJs",
  },
  {
    artist: "M.E.D.",
    trackInfo: "M.E.D. feat. Aloe Blacc - Where I'm From",
    url: "https://www.youtube.com/watch?v=T_X8AEHH15E",
  },
  {
    artist: "Dam-Funk",
    trackInfo: "Steve Arrington + Dam Funk + Stones Throw",
    url: "https://www.youtube.com/watch?v=VBvLLXG9Qc4",
  },
  {
    artist: "Dam-Funk",
    trackInfo: "Dam-Funk - Hood Pass Intact",
    url: "https://www.youtube.com/watch?v=Fcdpi16NfrY",
  },
  {
    artist: "Strong Arm Steady",
    trackInfo: "Strong Arm Steady - Cheeba Cheeba",
    url: "https://www.youtube.com/watch?v=3cCTbFqbbZE",
  },
  {
    artist: "Anika",
    trackInfo: "Anika - Yang Yang",
    url: "https://www.youtube.com/watch?v=CXstxFoayxI",
  },
  {
    artist: "Strong Arm Steady",
    trackInfo: "Strong Arm Steady - Chittlins & Pepsi",
    url: "https://www.youtube.com/watch?v=V3_6vfQHTeo",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - I NEED YOU",
    url: "https://www.youtube.com/watch?v=8eQbHE4prS0",
  },
  {
    artist: "M.E.D.",
    trackInfo: "M.E.D. - MEDical Card",
    url: "https://www.youtube.com/watch?v=xAWaNoyt4EI",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - Your Easy Lovin' Ain't Pleasin' Nothin'",
    url: "https://www.youtube.com/watch?v=RAxBdYM8opg",
  },
  {
    artist: "Bruce Haack",
    trackInfo:
      "Bruce Haack - Party Machine (Prince Language's Afterparty Edit)",
    url: "https://www.youtube.com/watch?v=fVRpXGGS8DQ",
  },
  {
    artist: "Strong Arm Steady",
    trackInfo:
      "Strong Arm Steady feat SICK JACKEN - PRESSURE - Prod. by MADLIB",
    url: "https://www.youtube.com/watch?v=3odUDZafE1I",
  },
  {
    artist: "Arabian Prince",
    trackInfo: "Arabian Prince - LETS HIT THE BEACH (CX KIDTRONIK REMIX)",
    url: "https://www.youtube.com/watch?v=jFzfJfqfpOE",
  },
  {
    artist: "Aloe Blacc",
    trackInfo: "Aloe Blacc - Loving You Is Killing Me (Live in Studio)",
    url: "https://www.youtube.com/watch?v=Ufz4i4NeeaE",
  },
  {
    artist: "Aloe Blacc",
    trackInfo: "Aloe Blacc - I Need a Dollar (Live in Studio)",
    url: "https://www.youtube.com/watch?v=lDyUhI1ArPo",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - I Left My Heart in San Francisco",
    url: "https://www.youtube.com/watch?v=_tLY1s9p8VU",
  },
  {
    artist: "James Pants",
    trackInfo: "James Pants - Thin Moon",
    url: "https://www.youtube.com/watch?v=w-h3ExiuZv4",
  },
  {
    artist: "Aloe Blacc",
    trackInfo: "Aloe Blacc - I Need A Dollar",
    url: "https://www.youtube.com/watch?v=iR6oYX1D-0w",
  },
  {
    artist: "Aloe Blacc",
    trackInfo: "Aloe Blacc - Find a Way",
    url: "https://www.youtube.com/watch?v=v23r1pwK-44",
  },
  {
    artist: "Strong Arm Steady",
    trackInfo: "Strong Arm Steady - Best of Times feat. Phonte",
    url: "https://www.youtube.com/watch?v=1JEDUqFEZHE",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - Thin Moon",
    url: "https://www.youtube.com/watch?v=Uy9fLe2umhY",
  },
  {
    artist: "Dam-Funk",
    trackInfo:
      "Dam-Funk - I Wanna Thank U 4 Steppin' Into My Life (Piano Version)",
    url: "https://www.youtube.com/watch?v=KMfIXuSVRek",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - One Track Mind",
    url: "https://www.youtube.com/watch?v=9tLkFMPaPzU",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - I Wish It Would Rain",
    url: "https://www.youtube.com/watch?v=JYHYAwvdHzY",
  },
  {
    artist: "Dam-Funk",
    trackInfo: "Dam-Funk - Mirrors",
    url: "https://www.youtube.com/watch?v=9TYf_qrw2WQ",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - Green Eyed Love",
    url: "https://www.youtube.com/watch?v=0Ijx-YtbYLg",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - Green Eyed Love (Classixx Remix)",
    url: "https://www.youtube.com/watch?v=9cruIgTuncY",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - Love Is All Right (4-inch vinyl)",
    url: "https://www.youtube.com/watch?v=gIVsKzjuPMA",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - Maybe So Maybe No",
    url: "https://www.youtube.com/watch?v=mpfcydeSGeo",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne Barbershop Quartet",
    url: "https://www.youtube.com/watch?v=dtvAZjIrKgE",
  },
  {
    artist: "Mayer Hawthorne",
    trackInfo: "Mayer Hawthorne - Just Ain't Gonna Work Out",
    url: "https://www.youtube.com/watch?v=pBKx8PyE5qQ",
  },
  {
    artist: "Madlib",
    trackInfo: "Madlib Lootpack - Crate Diggin'",
    url: "https://www.youtube.com/watch?v=_0LW8lKRp4Q",
  },
  {
    artist: "Madlib",
    trackInfo: "Madlib - For my Mans",
    url: "https://www.youtube.com/watch?v=XOu8jK7bLUM",
  },
  {
    artist: "Quasimoto",
    trackInfo: "Quasimoto - Closer ft. MF DOOM",
    url: "https://www.youtube.com/watch?v=KDDeNtlNTvg",
  },
  {
    artist: "Quasimoto",
    trackInfo: "Quasimoto - Low Class Conspiracy",
    url: "https://www.youtube.com/watch?v=iEHRz_4ROLQ",
  },
  {
    artist: "Jaylib",
    trackInfo: "Jaylib - The Official",
    url: "https://www.youtube.com/watch?v=kBzoPvOAsuI",
  },
  {
    artist: "Dam-Funk",
    trackInfo: "Dam-Funk - Toeachizown",
    url: "https://www.youtube.com/watch?v=S53cOe51W-s",
  },
  {
    artist: "James Pants",
    trackInfo: "James Pants - We're Through",
    url: "https://www.youtube.com/watch?v=qvErrmMZNVY",
  },
  {
    artist: "James Pants",
    trackInfo: "James Pants - Cosmic Rapp",
    url: "https://www.youtube.com/watch?v=4pPllLhQ7BU",
  },
  {
    artist: "Lootpack",
    trackInfo: "Madlib / Lootpack - Hityawitdat",
    url: "https://www.youtube.com/watch?v=rRxdyftPVeo",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Accordion",
    url: "https://www.youtube.com/watch?v=rpaonSDPw7Y",
  },
  {
    artist: "Lootpack",
    trackInfo: "Lootpack - Whenimondamic",
    url: "https://www.youtube.com/watch?v=e_EK3uYTIN0",
  },
  {
    artist: "Yesterdays New Quintet",
    trackInfo: "Yesterdays New Quintet - Solar Waves",
    url: "https://www.youtube.com/watch?v=6s4PnaaaxpU",
  },
  {
    artist: "Madlib",
    trackInfo: "Madlib - Beat Konducta in India",
    url: "https://www.youtube.com/watch?v=HZ_MYIljuIs",
  },
  {
    artist: "Jaylib",
    trackInfo: "Jaylib - Mcnasty Filth",
    url: "https://www.youtube.com/watch?v=07BHMfw6lTI",
  },
  {
    artist: "Percee P",
    trackInfo: "Percee P - Put it on the Line",
    url: "https://www.youtube.com/watch?v=MxuHQPMD7AE",
  },
  {
    artist: "Madlib",
    trackInfo: "Madlib - Slim's Return",
    url: "https://www.youtube.com/watch?v=apN0AXjJxQE",
  },
  {
    artist: "Quasimoto",
    trackInfo: "Quasimoto - Rappcats",
    url: "https://www.youtube.com/watch?v=ECGcQ6_Fj0Y",
  },
  {
    artist: "Quasimoto",
    trackInfo: "Quasimoto - Come on Feet",
    url: "https://www.youtube.com/watch?v=2_5edxArGT8",
  },
  {
    artist: "Aloe Blacc",
    trackInfo: "Aloe Blacc - Buskingh",
    url: "https://www.youtube.com/watch?v=rLFZdexQ-NM",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Rhinestone Cowboy",
    url: "https://www.youtube.com/watch?v=s4iR668Ki3I",
  },
  {
    artist: "M.E.D.",
    trackInfo: "M.E.D. - Push",
    url: "https://www.youtube.com/watch?v=mtgsWg5zjiU",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - All Caps",
    url: "https://www.youtube.com/watch?v=ewc1hixzYPY",
  },
  {
    artist: "James Pants",
    trackInfo: "James Pants - Do A Couple Of Things",
    url: "https://www.youtube.com/watch?v=d63FTZcImcU",
  },
  {
    artist: "Madvillain",
    trackInfo: "Madvillain - Monkey Suite",
    url: "https://www.youtube.com/watch?v=nzUY6Iiur6E",
  },
  {
    artist: "Madlib",
    trackInfo: "Madlib - Take It Back",
    url: "https://www.youtube.com/watch?v=Jd1m3Zai97A",
  },
  {
    artist: "J Dilla",
    trackInfo: "J Dilla - Nothing Like This",
    url: "https://www.youtube.com/watch?v=_ncSt5xC8Uk",
  },
]

const findArtists = tracks.map(t => t.artist)

const artists = findArtists.filter((element, index, self) => {
  return index === self.indexOf(element)
})

export function getTracks() {
  return tracks
}

export function getArtists() {
  return artists.sort()
}

export function selectedTrack(arr) {
  const track = arr[Math.floor(Math.random() * arr.length)]
  return track
}
